// WorkflowEngine constants

import { WorkflowStatus, TaskStepStatus, TaskType, GpxStatus } from "./types";

// Workflow-level status (parent rows in the table)
export const WORKFLOW_STATUS_LABELS: Record<WorkflowStatus, string> = {
  [WorkflowStatus.OPEN]: "Open",
  [WorkflowStatus.IN_PROGRESS]: "In progress",
  [WorkflowStatus.PENDING_REVIEW]: "Pending review",
  [WorkflowStatus.PENDING_EXTERNAL_APPROVAL]: "Pending external review",
  [WorkflowStatus.BLOCKED]: "Blocked",
  [WorkflowStatus.CLOSED]: "Closed",
  [WorkflowStatus.CANCELLED]: "Cancelled",
  [WorkflowStatus.RETURNED]: "Returned",
};

// Task-level status (child rows in the table). NOT_STARTED is intentionally
// surfaced as "Blocked" — a task that hasn't started is non-actionable to the
// user, so it reads the same as a manually-blocked task.
export const TASK_STEP_STATUS_LABELS: Record<TaskStepStatus, string> = {
  [TaskStepStatus.NOT_STARTED]: "Blocked",
  [TaskStepStatus.IN_PROGRESS]: "In progress",
  [TaskStepStatus.PENDING_REVIEW]: "Pending review",
  [TaskStepStatus.EXTERNAL_APPROVAL]: "Pending external approval",
  [TaskStepStatus.BLOCKED]: "Blocked",
  [TaskStepStatus.COMPLETED]: "Complete",
  [TaskStepStatus.SKIPPED]: "Skipped",
  [TaskStepStatus.RETURNED]: "Returned",
};

export const TASK_TYPE_LABELS: Record<TaskType, string> = {
  [TaskType.DATA_COLLECTION]: "Data Collection",
  [TaskType.MAKER_CHECKER]: "Maker/Checker",
  [TaskType.MULTI_PARTY_APPROVAL]: "Multi-Party Approval",
  [TaskType.EXTERNAL_APPROVAL]: "External Approval",
  [TaskType.DOCUMENT_UPLOAD]: "Document Upload",
};

// GP-facing (GPX) status labels — coarser than the FA-internal task statuses.
// Used in the GPX portal where GPs see a simplified view of task progress.
export const GPX_STATUS_LABELS: Record<GpxStatus, string> = {
  [GpxStatus.NOT_STARTED]: "Not started",
  [GpxStatus.IN_PROGRESS]: "In progress",
  [GpxStatus.IN_PROGRESS_RETURNED]: "Returned",
  [GpxStatus.READY_FOR_REVIEW]: "Ready for review",
  [GpxStatus.COMPLETE]: "Complete",
};

// SLA thresholds (hours)
export const SLA_THRESHOLDS = {
  WARNING_HOURS: 4,
  CRITICAL_HOURS: 2,
} as const;
